import React from 'react';
import c from 'classnames';
import UserLink from '../../../User/Link';
import s from './AuthorUserLink.scss';
/** A styled version of our user link. Looks different based on a couple PapiComment booleans (e.g. a featured variant). */
var AuthorUserLink = function (_a) {
    var comment = _a.comment, className = _a.className;
    var user = comment.user, isAuthorHighlited = comment.isAuthorHighlited, isFeatured = comment.isFeatured;
    return (React.createElement(UserLink, { withTooltip: true, user: user, className: c(s['root'], isAuthorHighlited && s['highlight'], isFeatured && s['featured'], className), relatedItemBiData: {
            typeid: comment.typeId,
            itemid: comment.itemId,
        } }));
};
AuthorUserLink.displayName = 'AuthorUserLink';
export default AuthorUserLink;
//# sourceMappingURL=AuthorUserLink.js.map